function toDate(value: string, start: number, length: number): string {
  try {
    return String(Number(value.substr( start, length )));
  } catch (err) {
    return '';
  }
}

/** yyyyMMdd形式にする */
export function formatDate(value: string, dateFormat: string = ''): string {
  if (value === null || value === '') {
    return '';
  }
  if (dateFormat === 'MM月dd日') {
    return toDate(value, 4, 2) + '月' + toDate(value, 6, 2) + '日';
  }
  if (dateFormat === 'yyyyMM') {
    return toDate(value, 0, 4) + '/' + toDate(value, 4, 2);
  }
  return toDate(value, 0, 4) + '/' + toDate(value, 4, 2) + '/' + toDate(value, 6, 2);
}

/** 金額形式にする */
export function formatPrice(value: string): string {
  if (value === null || value === '') {
    return '-';
  }
  if(value.substring(0,1) === '-'){
    var val = value.slice(1);
    return '￥-' + String(Number(val)).split(/(?=(?:\d{3})+$)/).join();
  }
  return '￥' + String(Number(value)).split(/(?=(?:\d{3})+$)/).join();
}

/** 金額形式($)にする */
export function formatPriceDoller(value: string): string {
  if (value === null || value === '') {
    return '-';
  }
  if(value.substring(0,1) === '-'){
    var val = value.slice(1);
    return '＄-' + String(Number(val)).split(/(?=(?:\d{3})+$)/).join();
  }
  return '＄' + String(Number(value)).split(/(?=(?:\d{3})+$)/).join();
}

/** 割合形式にする */
export function formatRate(value: string): string {
  if (value === null || value === '') {
    return '-';
  }
  return value + '%';
}

/** 数値に変換する */
export function toNumber(value: string): number {
  try {
    return Number(value);
  } catch (err) {
    return 0;
  }
}

export function format(msg: string, ...args: any[]): string {
  return msg.replace(/\{(\d+)\}/g, (m, k) => {
      return args[k];
  });
}

/** 権限チェック(admin) */
export function isAdmin(value: string): boolean {
  return (value === '2');
}

/** 権限チェック(agent) */
export function isAgent(value: string): boolean {
  return (value === '1');
}

/** 権限チェック(seller) */
export function isSeller(value: string): boolean {
  return (value === '0');
}

/** 権限チェック(seller) */
export function isLoginCheckWarn(value: string): boolean {
  return (value === '1');
}

export function log(v: any) {
  if(process.env.NODE_ENV !== 'production') {
    // tslint:disable-next-line:no-console
    // console.log(v);
  }
}

/** ハイフンを返却 */
export function checkBlank(value: string): string {
  if(value === null || value === ''){
    return '-';
  }
  return value;
}